export const defaultLanguage = "en";

export const supportedLanguages = [
	{ code: "en", name: "English" },
	{ code: "ar", name: "عربي / Arab" },
	{ code: "de", name: "Deutsch / German" },
	{ code: "fr", name: "French / Francais" },
	{ code: "es", name: "Spanish / Español" },
	{ code: "nn", name: "Language not specified in metadata" }
];